module.exports = __webpack_public_path__ + "static/f8-709b4a16b46ebeb0d5ebe7a7e2b30e30.jpeg";